<template>
    <BaseHero
        v-if="event"
        class="hero--event"
        :image="featuredImage"
    >
        <template #preTitle>
            <EventDisciplines :disciplines="event.disciplines" />

            <BaseLabel v-if="programLine">
                {{ programLine }}
            </BaseLabel>
        </template>

        <template #title>
            {{ event.oneLiner }}
        </template>

        <template #description>
            <EventMeta
                :event="event"
                class="event-meta--event-detail"
            >
                <template #artists>
                    <div
                        v-if="event.productionHouse?.name || event.artists?.length"
                        class="event-meta__item event-meta__artists event-artists--centered hero__makers"
                    >
                        <EventProductionHouse
                            :production-house="event.productionHouse"
                            :with-comma="!!event.artists?.length"
                        />

                        <EventArtist
                            v-if="event.artists?.length"
                            :artists="event.artists"
                        />
                    </div>
                </template>

                <template #venues>
                    <EventVenueLink
                        :venue="event.venue"
                    />
                </template>
            </EventMeta>

            <EventMemberActions
                :event="event"
                class="hero__actions"
            />

            <p v-if="event.isCancelled">
                Alle gemaakte reserveringen komen te vervallen
            </p>

            <p v-else-if="isNotActive">
                Je kunt niet meer reserveren
            </p>

            <p v-else-if="isNotReservable">
                Reserveren is helaas niet meer mogelijk
            </p>

            <EventPriceParagraph
                v-else
                :event="event"
            />
        </template>
    </BaseHero>
</template>

<script setup lang="ts">
import type { MediaAssetExtended } from '~/types/craft-schema.extended';
import { useEventsStore } from '~/stores/events';

const props = defineProps<{ event: EventDate }>();

const eventsStore = useEventsStore();
const programLine = props.event.programLine
    ? props.event.programLine.name
    : null;

const isNotReservable = computed(() =>
    (
        !eventsStore.isWaitingListEnabled
        && eventsStore.isFullyBooked
    )
    || props.event.isSoldout
);

const isNotActive = !props.event.isActive;

const featuredImage = {
    __typename: 'media_Asset',
    url_hero_xs: props.event.featuredImage?.url_hero_xs,
    url_hero_sm: props.event.featuredImage?.url_hero_sm,
    url_hero_md: props.event.featuredImage?.url_hero_md,
    url_hero_lg: props.event.featuredImage?.url_hero_lg,

    webp_url_hero_xs: props.event.featuredImage?.url_hero_xs_webp,
    webp_url_hero_sm: props.event.featuredImage?.url_hero_sm_webp,
    webp_url_hero_md: props.event.featuredImage?.url_hero_md_webp,
    webp_url_hero_lg: props.event.featuredImage?.url_hero_lg_webp,

    alt: props.event.featuredImage?.alt ?? undefined,
    credits: props.event.featuredImage?.credits ?? undefined,
    width: props.event.featuredImage?.width,
    height: props.event.featuredImage?.height,
    extension: '',
    filename: props.event.featuredImage?.conversion_name,
    folderId: 0,
    hasFocalPoint: false,
    kind: '',
    path: ''
} as MediaAssetExtended;
</script>

<style lang="less" src="./EventHero.less"></style>
